export const features = [
  {
    id: 1,
    title: 'Manage anxiety',
    subtitle: '& overthinking',
    icon: 'brain',
    description: 'Calm a racing mind with proven techniques tailored to your unique experience.'
  },
  {
    id: 2,
    title: 'Overcome sadness',
    subtitle: '& low mood',
    icon: 'cloud',
    description: 'Find light again with gentle, structured support through difficult emotions.'
  },
  {
    id: 3,
    title: 'Build self-confidence',
    subtitle: '& inner strength',
    icon: 'sparkle',
    description: 'Reconnect with your worth and rediscover the strength that has always been within.'
  },
  {
    id: 4,
    title: 'Personalized care',
    subtitle: 'with empathy',
    icon: 'heart-hand',
    description: 'A safe, non-judgmental space designed entirely around your healing journey.'
  },
];

export const expectations = [
  'A safe & non-judgmental space',
  'Practical tools & coping strategies',
  'Emotional support & guidance',
  'Better mental well-being',
  'A path towards a happier you',
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya R.',
    quote: 'Santhosha created such a warm, safe space. After a few sessions I finally felt I could breathe again.',
    role: 'Client, 6-month journey',
  },
  {
    id: 2,
    name: 'Arjun K.',
    quote: 'The tools and techniques I learned are still with me. I feel more in control of my thoughts.',
    role: 'Client, anxiety support',
  },
  {
    id: 3,
    name: 'Meera S.',
    quote: 'Compassionate, patient and deeply understanding. Truly a path towards a happier me.',
    role: 'Client, mood support',
  },
];

export const faqs = [
  {
    q: 'How do sessions work?',
    a: 'Sessions are confidential, one-on-one conversations conducted in a calm, safe environment — either in-person or online. Each session is paced to your comfort.'
  },
  {
    q: 'How long is each session?',
    a: 'A typical session lasts 45 to 60 minutes. The first session is slightly longer so we can understand your needs in depth.'
  },
  {
    q: 'Is everything kept confidential?',
    a: 'Absolutely. Your privacy is protected. Nothing you share leaves the session unless you choose otherwise.'
  },
  {
    q: 'How many sessions will I need?',
    a: 'Every journey is unique. Some find relief in a few sessions, others benefit from longer-term support. We will decide together what is right for you.'
  },
  {
    q: 'How do I book?',
    a: 'You can reach out via WhatsApp or call at 8088588389. We will find a time that works for you and begin gently.'
  },
];

export const contact = {
  name: 'Santhosha',
  phone: '8088588389',
  whatsapp: '8088588389',
  email: 'santhosha@natural-care.co.in',
  website: 'natural-care.co.in',
  address: {
    line1: 'No 3, Samruddi Nilaya',
    line2: 'Jodi Bhavi Road, Nagasandra',
    city: 'Bangalore, Karnataka 560073',
    full: 'No 3 Samruddi Nilaya, Jodi Bhavi Road, Nagasandra, Bangalore, Karnataka 560073'
  },
  tagline: 'Healing is possible. You are not alone. I am here to support you.'
};

export const santhoshaImg = 'https://customer-assets.emergentagent.com/job_img-web-creator-4/artifacts/dkxy3rw0_WhatsApp%20Image%202026-06-11%20at%2023.43.38.jpeg';

export const natureBg = {
  forest: 'https://images.unsplash.com/photo-1542157565-4607d82cf417',
  waterfall: 'https://images.unsplash.com/photo-1694912183138-242063ae6e40',
  moss: 'https://images.unsplash.com/photo-1582137363701-90dfd38fe801',
};
